import { supabase } from '@/integrations/supabase/client';

export type OnboardingSlot = 'pre_student' | 'pre_visitor' | 'post_login';

export interface OnboardingConfig {
  slot: OnboardingSlot;
  video_url: string | null;
  title: string;
  description: string;
  cta_label: string;
  version: number;
  updated_at: string;
}

export async function fetchAllOnboardingConfigs(): Promise<OnboardingConfig[]> {
  const { data, error } = await supabase
    .from('onboarding_config' as any)
    .select('*');
  if (error) throw error;
  return (data || []) as unknown as OnboardingConfig[];
}

export async function fetchOnboardingConfig(slot: OnboardingSlot): Promise<OnboardingConfig | null> {
  const { data, error } = await supabase
    .from('onboarding_config' as any)
    .select('*')
    .eq('slot', slot)
    .maybeSingle();
  if (error) throw error;
  return (data || null) as unknown as OnboardingConfig | null;
}

export async function updateOnboardingConfig(
  slot: OnboardingSlot,
  patch: Partial<Pick<OnboardingConfig, 'video_url' | 'title' | 'description' | 'cta_label' | 'version'>>,
): Promise<void> {
  const { error } = await supabase
    .from('onboarding_config' as any)
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('slot', slot);
  if (error) throw error;
}